export const ControlQA = {
    showInnerTitleCheckbox: 'show-inner-title-checkbox',
    controlLabel: 'chartkit-control-title',

    controlSelect: 'chartkit-control-select',
    controlInput: 'chartkit-control-input',
    controlButtonApply: 'control-button-apply',
    controlButtonReset: 'control-button-reset',

    controlSelectItems: 'chartkit-control-select-items',
    inputInnerLabelControl: 'control-inner-label-input',
    inputNameControl: 'control-name-input',
    controlLinks: 'dashkit-overlay-control-links',
    controlMenu: 'dashkit-overlay-control-menu',
    controlSettings: 'dashkit-overlay-control-settings',
    controlSelectAcceptable: 'control-select-acceptable',
    controlSelectAcceptableInput: 'control-select-acceptable-input',
    controlSelectAcceptableButton: 'control-select-acceptable-button',
    controlSelectAcceptableItem: 'control-select-acceptable-item',
    controlSelectAcceptableRemoveButton: 'control-select-acceptable-remove',
    chartkitControl: 'chartkit-control',
    groupChartkitControl: 'group-chartkit-control',
    selectDefaultAcceptable: 'select-default-acceptable',
    acceptableDialogButton: 'acceptable-dialog-button',
    filtersClear: 'filters-clear',

    dialogControl: 'dialog-control',
    dialogControlApplyBtn: 'control-dialog-apply-button',
    dialogControlCancelBtn: 'control-dialog-cancel-button',

    groupCommonLockedBlock: 'group-control-common-locked-block',

    errorBlock: 'type-error',
};

export const DialogControlQa = {
    selectDatasetButton: 'dialog-control-select-dataset-button',
    elementTypeSelect: 'dialog-control-element-type-select',
    fieldSelect: 'dialog-control-field-select',
    valueSelect: 'dialog-control-value-select',
    valueInput: 'dialog-control-value-input',
    radioSourceType: 'radio-source-type',
    seletSourceType: 'select-source-type',
    appearanceTitle: 'dialog-control-appearance-title',
    appearanceTitlePlacement: 'dialog-control-appearance-title-placement',
    appearanceInnerTitle: 'dialog-control-appearance-inner-title',
    fieldNameInput: 'field-name-input',
    dateRangeCheckbox: 'date-range-checkbox',
    dateTimeCheckbox: 'date-time-checkbox',
    requiredValueCheckbox: 'dialog-control-required-checkbox',

    typeControlCalendar: 'type-control-calendar',
    typeControlSelect: 'type-control-select',
    typeControlInput: 'type-control-input',
    typeControlCheckbox: 'type-control-checkbox',
};

export const DialogControlParamsQa = {
    buttonApply: 'dialog-control-params-apply-button',
    buttonCancel: 'dialog-control-params-cancel-button',
};

export const DialogGroupControlQa = {
    autoHeightCheckbox: 'autoheight-checkbox',
    applyButtonCheckbox: 'apply-button-checkbox',
    resetButtonCheckbox: 'reset-button-checkbox',
    updateControlOnChangeCheckbox: 'update-controls-button-checkbox',
    extendedSettingsButton: 'extended-settings-button',
    placementControlList: 'selectors-placement-control-list',
    extendedSettingsApplyButton: 'selectors-extended-settings-apply-button',
    controlMenu: 'control-menu',
    removeControlButton: 'remove-control-button',
    copyControlButton: 'copy-control-button',
    duplicateControlButton: 'duplicate-control-button',
};

export const DialogControlDateQa = {
    defaultNotDefined: 'default-date-not-defined',
    defaultSelectValue: 'default-date-select-value',
};
